export default __webpack_public_path__ + "static/media/tripleLine.a0154d29.svg";